import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { IShareAccess } from '../activity/user-card.interface';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { ViewAllSharedAccessComponent } from './view-all-shared-access/view-all-shared-access.component';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/utils/common.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';

@Component({
  selector: 'app-dashboard-share-access-card',
  templateUrl: './dashboard-share-access-card.component.html',
  styleUrls: ['./dashboard-share-access-card.component.scss'],
})
export class DashboardShareAccessCardComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;

  @Input() shareAccess!: IShareAccess;
  @Input() siteId!: string;
  subscription: Subscription | undefined;
  sharedData: any;
  commonAccessControl!: boolean;

  constructor(
    private helperService: HelperService,
    public dashboardManagementService: DashboardManagementService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,
    private stateManagementService: StateManagementService
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.subscription = this.sharedDataService?.currentData?.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
  }

  /**
   *#openViewAllModal function will open the modal for view all shared access available.
   * @param {none}
   */
  openViewAllModal() {
    const dialogInstance = this.helperService.openModalDialog(
      ViewAllSharedAccessComponent,
      {
        siteId: this?.siteId,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
  }

  /**
   * Handle the click event when accessing a specific resource.
   * @param access - The access object representing the resource.
   */
  onClickAccess(access: any) {
    // Set the selected building, floor, and access point or unit data
    this.sharedDataService.setAllEntityData(access);

    // Navigate to the site management page
    this.router.navigate(['../site-management']);
  }
}
